class ValidationResult
	string	errorMessage
	string	lastValidValue

class DropdownState
	string[]	filteredOptions
	bool	showDropdown
	int	selectedIndex	= -1
	float	lastBlurTime

class ImageDragState
	bool	active
	int	pointerId	= -1
	int	sourceIndex	= -1
	int	targetIndex	= -1
	float	x
	float	y
	float	offsetX
	float	offsetY
	float	width	= 128
	float	height	= 128
	string	image

class ValidationState
	private string[string]	errorForLabel = {}
	private bool[string]	shouldValidateForLabel = {}
	bool	showErrrorsForEmptyFields = false

	clear
		errorForLabel.clear
		shouldValidateForLabel.clear
		showErrrorsForEmptyFields = false

	set: string label, string errorMessage
		if errorMessage then errorForLabel[label] = errorMessage
		else             errorForLabel.remove(label)

	get: string label
		return errorForLabel[label] or ""

	setShouldValidate: string label, bool shouldValidate = true
		this.shouldValidateForLabel[label] = shouldValidate

	shouldValidate: string label
		return shouldValidateForLabel[label] or showErrrorsForEmptyFields

	overrideError: string label, string message = ""
		errorForLabel[label] = message
		shouldValidateForLabel[label] = false
		showErrrorsForEmptyFields = false

	js void scrollToFirstError
		let element = document.querySelector('.validation-error');
		if (element) {
			let rect = element.getBoundingClientRect();
			if (rect.top < 0 || rect.bottom > window.innerHeight) element.scrollIntoView({behavior:"smooth", block:"center"});
		}
		else {
			window.scrollTo(0,0);
		}

	checkForErrorsOrEmptyFields
		showErrrorsForEmptyFields = true
		refresh
		if errorForLabel.length > 0
			scrollToFirstError
			return true
		return false

	errorCount
		return errorForLabel.length

form
	ImageDragState	imageDrag = {}
	dynamic	imageDragMove
	dynamic	imageDragUp
	dynamic	imageDragCancel
	dynamic	imageDragSlots

	showErrorMessage: string errorMessage
		if errorMessage != ""
			div text:errorMessage, fontSize:12, color:#ef4444, marginBottom:8

	drawImageThumbnail: dynamic model, string image
		string imageUrl = image.startsWith("data:") ? image : "{backend.url}/api/files/goods/{model.container.id}/{image}"
		img src:imageUrl, width:100%, height:100%, objectFit:contain, borderRadius:8

	js void stopImageDrag: dynamic state
		if(form.imageDragMove) document.removeEventListener("pointermove", form.imageDragMove);
		if(form.imageDragUp) document.removeEventListener("pointerup", form.imageDragUp);
		if(form.imageDragCancel) document.removeEventListener("pointercancel", form.imageDragCancel);
		form.imageDragMove = null;
		form.imageDragUp = null;
		form.imageDragCancel = null;
		form.imageDragSlots = null;
		state.active = false;
		state.pointerId = -1;
		state.sourceIndex = -1;
		state.targetIndex = -1;
		state.image = "";
		document.body.style.cursor = "";

	js void updateImageDragPosition: dynamic state, float pageX, float pageY
		const scale = Platform.scale || 1;
		state.x = pageX / scale;
		state.y = pageY / scale;

	js void cacheImageDropSlots: string groupId
		const elements = document.querySelectorAll('[imageDragGroup="' + groupId + '"][imageIndex]');
		const slots = [];
		const scale = Platform.scale || 1;
		for(const element of elements) {
			const rect = element.getBoundingClientRect();
			const index = Number(element.getAttribute("imageIndex"));
			slots.push({x: (rect.left + window.pageXOffset + rect.width * 0.25) / scale, y: (rect.top + window.pageYOffset + rect.height / 2) / scale, index:index});
			slots.push({x: (rect.left + window.pageXOffset + rect.width * 0.75) / scale, y: (rect.top + window.pageYOffset + rect.height / 2) / scale, index:index + 1});
		}
		form.imageDragSlots = slots;

	js int getClosestImageDropIndex: string groupId, float pageX, float pageY
		const scale = Platform.scale || 1;
		const x = pageX / scale;
		const y = pageY / scale;
		if(!form.imageDragSlots || !form.imageDragSlots.length) {
			form.cacheImageDropSlots(groupId);
		}
		const slots = form.imageDragSlots;
		if(!slots || !slots.length) return 0;
		let bestIndex = slots[0].index;
		let bestDistance = Number.POSITIVE_INFINITY;
		for(const slot of slots) {
			const distance = Math.hypot(slot.x - x, slot.y - y);
			if(distance < bestDistance) {
				bestDistance = distance;
				bestIndex = slot.index;
			}
		}
		return bestIndex;

	js void enableImageReorder: HTMLElement element
		                             dynamic state
		                             string groupId
		                             int index
		                             string image
		                             dynamic model
		element.style.touchAction = "none";
		element.onpointerdown = ev => {
			if(ev.button !== 0 || app.goods.busy) return;
			if(ev.target && ev.target.getAttribute && ev.target.getAttribute("removeImage") == "true") return;
			ev.preventDefault();
			form.stopImageDrag(state);
			form.cacheImageDropSlots(groupId);
			const rect = element.getBoundingClientRect();
			state.active = true;
			state.pointerId = ev.pointerId;
			state.sourceIndex = index;
			state.targetIndex = index;
			state.image = image;
			const scale = Platform.scale || 1;
			state.width = rect.width / scale;
			state.height = rect.height / scale;
			state.offsetX = (ev.pageX - window.pageXOffset - rect.left) / scale;
			state.offsetY = (ev.pageY - window.pageYOffset - rect.top) / scale;
			form.updateImageDragPosition(state, ev.pageX, ev.pageY);
			document.body.style.cursor = "grabbing";
			form.imageDragMove = moveEvent => {
				if(moveEvent.pointerId !== state.pointerId) return;
				moveEvent.preventDefault();
				form.updateImageDragPosition(state, moveEvent.pageX, moveEvent.pageY);
				state.targetIndex = form.getClosestImageDropIndex(groupId, moveEvent.pageX, moveEvent.pageY);
				html.refresh();
			};
			form.imageDragUp = async upEvent => {
				if(upEvent.pointerId !== state.pointerId) return;
				upEvent.preventDefault();
				const sourceIndex = state.sourceIndex;
				const targetIndex = state.targetIndex;
				const finalIndex = targetIndex > sourceIndex ? targetIndex - 1 : targetIndex;
				form.stopImageDrag(state);
				if(finalIndex === sourceIndex) {
					html.refresh();
					return;
				}
				const previous = (model.container[model.key] || []).slice();
				const reordered = previous.slice();
				const movedImage = reordered.splice(sourceIndex, 1)[0];
				reordered.splice(finalIndex, 0, movedImage);
				model.container[model.key] = reordered;
				html.refresh();
				try {
					if(model.container.id) await app.goods.update(model.container, {[model.key]: reordered});
				} catch(error) {
					model.container[model.key] = previous;
					console.error(error);
					alert("Die Reihenfolge der Bilder konnte nicht gespeichert werden.");
					html.refresh();
				}
			};
			form.imageDragCancel = cancelEvent => {
				if(cancelEvent.pointerId !== state.pointerId) return;
				form.stopImageDrag(state);
				html.refresh();
			};
			document.addEventListener("pointermove", form.imageDragMove, {passive:false});
			document.addEventListener("pointerup", form.imageDragUp, {passive:false});
			document.addEventListener("pointercancel", form.imageDragCancel, {passive:false});
			html.refresh();
		};

	// Renders a label with required asterisk and help tooltip
	drawLabel: string name, bool required, string help
		state bool showHelp = false
		if name != ""
			div display:flex, alignItems:center
				html.div text:name, fontSize:14, color:#40465a, fontWeight:500
				if required then html.div text:"*", fontSize:14, color:#40465a, fontWeight:500, marginLeft:2
				if help != "" and help != null
					div position:relative marginLeft:8
						img Info width:15 padding:{top:4} onPointerOver: showHelp = true; refresh
							onPointerOut: showHelp = false; refresh
						if showHelp
							div position:absolute, backgroundColor:#2b3145, color:#ffffff
								padding:{top:8 bottom:8 left:12 right:12}, borderRadius:8
								fontSize:12, zIndex:1000, width:200, left:30, top:0
								boxShadow:{offset:{0,4}, blur:8, spread:0, color:#00000020}
								div text:help

	// A html input element with a dropdown list of options
	// Example:
	//     form.dropdown label:"Color", model:selectedColor, options:["Red", "Green", "Blue"]
	dropdown: string label
		      Reference<string> model
			  Dimension width = 100%
		      string[] options
		      bool allowCustomValues = false
		      int minTextLength = 1
		      int maxTextLength = 100
			  void(string value) onChange = null
			  void(string value) onInput = null
			  bool required = false
			  string help = ""
			  ValidationState validationState = {}
		state DropdownState state = {}
		state string lastValidValue = ""
		let currentValue = model or ""
		
		let container = column
			drawLabel label, required, help
			div position:relative, overflow:visible, width
				var input = input width:100% value:currentValue
					borderRadius:8 border:{2px solid #d1d5db} padding:{12 40 12 16}
					cursor:text, fontSize:16, color:#2b3145, position:relative
					outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
				onInput: value =>
					model = value
					let lowercaseValue = value.toLowerCase
					state.filteredOptions.setFilteredList options, condition:.toLowerCase.includes(lowercaseValue)
					state.selectedIndex = value ? 0 : -1
					if onInput != null then onInput(value)
					refresh
				onKeyDown:
					if ev.keyCode == Up and state.selectedIndex > 0
						state.selectedIndex--; ev.preventDefault; refresh
					if ev.keyCode == Down and state.selectedIndex < state.filteredOptions.length - 1
						state.selectedIndex++; ev.preventDefault; refresh
					if ev.keyCode == Enter and state.selectedIndex >= 0
						model = state.filteredOptions[state.selectedIndex]
						state.showDropdown = false
						if onInput != null then	onInput(model or "")
						refresh
				onFocus:
					state.showDropdown = true
					state.filteredOptions.setList options
					state.selectedIndex = state.filteredOptions.indexOf(model)
					state.lastBlurTime = 0
					refresh
				onBlur:
					if model then validationState.setShouldValidate(label)
					state.lastBlurTime = Time.now
					if onChange != null then onChange(model or "")
					refresh
				img OpenDropdown, width:32, padding:{19 8}, cursor:pointer, position:absolute, right:10, top:0
				onPointerDown:
					ev.preventDefault
					if not state.showDropdown and Time.now - state.lastBlurTime > 200
						state.showDropdown = true
						state.filteredOptions.setList options
						state.selectedIndex = state.filteredOptions.indexOf(model)
						input.focus
					state.lastBlurTime = 0
					refresh
				if state.showDropdown
					div position:fixed, inset:{all:0}, zIndex:1000, backgroundColor:#00000008
					onPointerDown:
						state.showDropdown = false
						state.lastBlurTime = Time.now
						refresh
					var dropdown = div border:{1px solid #e2e8f0} borderRadius:8
						width, position:absolute, backgroundColor:white, zIndex:1003
						margin:{top:4}, boxShadow:{10px 10px 25px #00000010},
						overflowY:auto, maxHeight:400px
						for state.filteredOptions as option
							div text:option padding:{12px 16px} color:#2d3748
							borderLeft:{3px solid i == state.selectedIndex ? primaryColor : transparent}
							backgroundColor:i == state.selectedIndex ? lightColor : white
							cursor:pointer
							styleWhenHovering: {borderLeft:{3px solid primaryColor}, backgroundColor:lightColor}
							onClick:
								model = option
								state.showDropdown = false
								state.lastBlurTime = Time.now
								validationState.set(label, "")
								lastValidValue = option
								if onInput != null then	onInput(option)
								refresh
					dropdown.style.webkitOverflowScrolling = "touch"
					dropdown.style.overscrollBehavior = "contain"
					dropdown.style.overscrollBehaviorY = "contain"
					dropdown.style.touchAction = "pan-y"

			if validationState.shouldValidate(label)
				if not currentValue and required then	validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				if currentValue and not allowCustomValues and options.indexOf(currentValue) == -1 then validationState[label] = "Bitte wählen Sie einen Wert aus der Liste aus." else
				                                        validationState[label] = ""
			showErrorMessage validationState[label]
		container.set "class", validationState[label] ? "validation-error" : ""

	// Example:
	//     form.text label:"Name", model:userName
	text: string label
		  Reference<string> model
		  Dimension width = 100%
		  int rows = 1
		  int minTextLength = 1
		  int maxTextLength = 100
		  void(string value) onChange = null
		  void(string value) onInput = null
		  bool required = false
		  ValidationState validationState = {}
		  string help = ""
		  bool focusInitially = false
		let container = column width
			drawLabel label, required, help
			string currentValue = model or ""
			input width:100%, value:currentValue, focusInitially, rows
				borderRadius:8 border:{2px solid #d1d5db} padding:{12 16}
				outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
				fontSize:16, color:#2b3145
			onInput: value =>
				model = value
				if onInput != null then onInput(value)
				refresh
			onBlur:
				if model then	validationState.setShouldValidate(label)
				if onChange != null then	onChange(model)
				refresh

			if validationState.shouldValidate(label)
				if not currentValue and required then validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				if currentValue.length < minTextLength and (required or currentValue.length > 0) then validationState[label] = "Bitte füllen Sie dieses Feld vollständig aus." else
				if currentValue.length > maxTextLength then validationState[label] = "Bitte geben Sie maximal {maxTextLength} Zeichen ein" else
				                                        validationState[label] = ""
			showErrorMessage validationState[label]
		container.set "class", validationState[label] ? "validation-error" : ""

	// A number input field
	// Example:
	//     form.number label:"Price", model:price, unit:"€"
	number: string label = ""
		    Reference<float> model
		    Dimension width = 100%
		    string unit = ""
		    string thousandsSeparator = " "
		    float minNumber = 0.0
		    float maxNumber = float.maxValue
		    void(float value) onChange = null
		    void(float value) onInput = null
		    bool required = false
		    string help = ""
		    ValidationState validationState = {}
		float currentValue = model
		
		let container = column
			drawLabel label, required, help
			div display:flex, alignItems:center, gap:8, position:relative
				input width:width value:currentValue.isValidNumber ? (thousandsSeparator ? currentValue.format(maxFractionDigits:20, grouping:true).replaceAll("," with thousandsSeparator) : currentValue.toString) : ""
					borderRadius:8 border:{2px solid #d1d5db} padding:{12 16}
					outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
					fontSize:16, color:#2b3145
				onInput: value =>
					let floatValue = (thousandsSeparator ? value.replaceAll(thousandsSeparator with "") : value).toFloat
					model = floatValue
					if onInput != null then onInput(floatValue)
				onBlur:
					if model then	validationState.setShouldValidate(label)
					if onChange != null then	onChange(model)
					refresh
				if unit != ""
					div text:unit, fontSize:16, color:#7a8195, position:absolute, right:16

			if validationState.shouldValidate(label)
				if !currentValue and currentValue != 0 and required then validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				if currentValue < minNumber and (required or currentValue != 0) then validationState[label] = "Der Wert muss mindestens {minNumber} betragen." else
				if currentValue > maxNumber then validationState[label] = "Der Wert darf maximal {maxNumber} betragen." else
				                                 validationState[label] = ""
			showErrorMessage validationState[label]
		container.set "class", validationState[label] ? "validation-error" : ""

	// A date input field (local date picker, stored as UTC TimeString)
	date: string label
		  Reference<string> model
		  Dimension width = 100%
		  void(string value) onChange = null
		  void(string value) onInput = null
		  bool required = false
		  string help = ""
		  ValidationState validationState = {}
		state string draftValue = ""
		state bool isEditing = false
		let currentValue = model or ""
		string localDateValue = ""
		string displayValue = draftValue
		if currentValue
			Date dt = Date(currentValue)
			localDateValue = "{dt.year}-{dt.twoDigitMonth}-{dt.twoDigitDay}"
			if not isEditing or draftValue == "" then displayValue = "{dt.twoDigitDay}.{dt.twoDigitMonth}.{dt.year}"
		else
			if not isEditing then displayValue = ""
		
		let container = column
			drawLabel label, required, help
			div position:relative, width
				input width:100%, value:displayValue
					borderRadius:8 border:{2px solid #d1d5db} padding:{12 40 12 16}
					outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
					fontSize:16, color:#2b3145
					data:{type:"text"}
				onInput: value =>
					isEditing = true
					if not value
						model = ""
						draftValue = ""
						if onInput != null then onInput(model)
						refresh
						return
					string[] parts = value.split(".")
					if parts.length == 3 and parts[0].length == 2 and parts[1].length == 2 and parts[2].length == 4
						int day = cast parts[0]
						int month = cast parts[1]
						int year = cast parts[2]
						Date dt = Date.fromValues year, month, day, 23, 59, 59
						model = "{dt.utcString}"
						draftValue = ""
					else
						draftValue = value
					if onInput != null then onInput(model)
					refresh
				onBlur:
					isEditing = false
					if model then validationState.setShouldValidate(label)
					if onChange != null then onChange(model)
					refresh

				let nativeInput = input width:28px, value:localDateValue
					position:absolute, right:8, top:8, height:28px, opacity:0
					pointerEvents:auto
					borderRadius:8, border:{2px solid transparent}
					data:{type:"date"}
				onInput: value =>
					if not value then return
					string[] parts = value.split("-")
					if parts.length == 3
						int year = cast parts[0]
						int month = cast parts[1]
						int day = cast parts[2]
						Date dt = Date.fromValues year, month, day, 23, 59, 59
						model = "{dt.utcString}"
						draftValue = ""
						if onInput != null then onInput(model)
						refresh

				div text:"📅", position:absolute, right:12, top:10, cursor:pointer, pointerEvents:none
					fontSize:18, color:#7a8195

			if validationState.shouldValidate(label)
				if not currentValue and required then validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				                                      validationState[label] = ""
			showErrorMessage validationState[label]
		container.set "class", validationState[label] ? "validation-error" : ""

	// Renders a field with label and appropriate input
	// Example:
	//     form.drawField field, new Reference(container:good, key:field.fieldName)
	drawField: Field field
	           Reference<dynamic> model
	           void(dynamic value) onInput = null
	           void(dynamic value) onChange = null
	           ValidationState validationState = {}
		let label = field.description or field.name
		switch field.dataType
			SelectOne:
				let options = field.options.length > 0 ? field.options[0].values : []
				dropdown label, model, options
					allowCustomValues:field.allowCustomValues
					minTextLength:field.minTextLength ? field.minTextLength : 1
					maxTextLength:field.maxTextLength ? field.maxTextLength : 100
					required:field.required
					help:field.help
					validationState
					onInput: value => if onInput != null then	onInput(value)
					onChange: value => if onChange != null then	onChange(value)
			Toggle:
				toggle label, model, onInput: value => if onInput != null then onInput(value)
			Text:
				text label, model
					minTextLength:field.minTextLength ? field.minTextLength : 1
					maxTextLength:field.maxTextLength ? field.maxTextLength : 100
					rows:field.rows or 1
					required:field.required
					help:field.help
					validationState
					onInput: value => if onInput != null then	onInput(value)
					onChange: value => if onChange != null then	onChange(value)
			Number:
				number label, model, unit:field.unit
					minNumber:field.minNumber ? field.minNumber : int.minValue
					maxNumber:field.maxNumber ? field.maxNumber : int.maxValue
					required:field.required
					help:field.help
					thousandsSeparator:field.thousandsSeparator ? " " : ""
					validationState
					onInput: value => if onInput != null then	onInput(value)
					onChange: value => if onChange != null then	onChange(value)
			Date:
				date label, model
					required:field.required
					help:field.help
					validationState
					onInput: value => if onInput != null then	onInput(value)
					onChange: value => if onChange != null then	onChange(value)
			Images:
				string dragGroupId = "{model.key}"
				if model.container.id then dragGroupId = "{model.container.id}-{model.key}"
				drawLabel label, field.required, field.help
				string[] images = model.value or []
				row gap:12px flexWrap:wrap width:100% marginTop:12 alignItems:start
					for images as image
						if form.imageDrag.active and form.imageDrag.targetIndex == i
							div width:128 height:128 borderRadius:8 backgroundColor:#d1d5db
								data:{imageDragGroup:dragGroupId}
						if not form.imageDrag.active or i != form.imageDrag.sourceIndex
							let tile = div width:128 height:128 position:relative overflow:visible borderRadius:8
								display:flex, alignItems:center, justifyContent:center
								backgroundColor:#f3f4f6, boxShadow:{offset:{0,4}, blur:12, spread:0, color:#00000010}
								cursor:grab, userSelect:"none"
								data:{imageDragGroup:dragGroupId imageIndex:i}
								border:{2px solid #d0d0d0}
								drawImageThumbnail model, image
								img Remove, width:24, position:absolute, right:-8, top:-8, cursor:pointer
									data:{removeImage:true}
									onPointerDown:
										ev.stopPropagation
									app.goods.removeFile model, image
							enableImageReorder tile, form.imageDrag, dragGroupId, i, image, model
					if form.imageDrag.active and form.imageDrag.targetIndex == images.length
						div width:128 height:128 borderRadius:8 backgroundColor:#d1d5db
							data:{imageDragGroup:dragGroupId}
					html.fileInput multiple:true capture:none
						div width:128px height:128px border:{2px solid #e0e0e0} borderRadius:8 display:flex flexDirection:column alignItems:center justifyContent:center gap:8
							img Add width:48px
							div "Bilder hochladen" fontSize:12 color:#6b7280
					onChange:
						html.closeDetails
						await app.goods.addFiles model, .files
							onError: alert delay:100, "Die folgenden Dateien konnten nicht hochgeladen werden:\n{.joinToString.name separator:"\n"}\n\nBitte prüfen Sie, ob die Dateien gültige JPEG oder PNG Bilder sind und versuchen Sie es nochmal. Falls das Problem erneut auftritt, könnte die Bilder in einem ungülten Format oder beschädigt sein. Wir empfehlen, die betroffenen Fotos erneut aufzunehmen. "
				if form.imageDrag.active and form.imageDrag.image
					div position:fixed, left:form.imageDrag.x - form.imageDrag.offsetX, top:form.imageDrag.y - form.imageDrag.offsetY
						width:form.imageDrag.width, height:form.imageDrag.height, borderRadius:8, overflow:hidden
						display:flex, alignItems:center, justifyContent:center
						backgroundColor:#f3f4f6, boxShadow:{offset:{0,12}, blur:24, spread:0, color:#00000020}
						opacity:0.95, pointerEvents:none, zIndex:2000
						drawImageThumbnail model, form.imageDrag.image
				if images then html.closeDetails
				if app.goods.busy
					row alignItems:center marginTop:8 gap:4
						img ProgressA, width:40
						div "Wird hochgeladen..."

	// Email input field
	email: string label
		   Reference<string> model
		   Dimension width = 100%
		   void(string value) onChange = null
		   void(string value) onInput = null
		   bool required = false
		   ValidationState validationState = {}
		   string help = ""
		   bool focusInitially = false
		   string autocomplete = "email"
		   string name = "email"
		let currentValue = model or ""
		
		let container = column
			drawLabel label, required, help
			input width, value:currentValue, focusInitially
				borderRadius:8, border:{2px solid #d1d5db}
				outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
				padding:{12 16}, fontSize:16, color:#2b3145
				data:{type:"email", autocomplete, name}
			onInput: value =>
				model = value
				if onInput != null then onInput(value)
				refresh
			onBlur:
				System.log "email: onBlur", ev.target, ev.currentTarget
				if model then	validationState.setShouldValidate(label)
				if onChange != null then	onChange(model)
				refresh

			if validationState.shouldValidate(label)
				if not currentValue and required then  validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				if not currentValue.isEmail then       validationState[label] = "Bitte geben Sie eine gültige E-Mail-Adresse ein" else
				                                       validationState[label] = ""
			showErrorMessage validationState[label]
		container.set "class", validationState[label] ? "validation-error" : ""

	// Password input field
	password: string label
		      Reference<string> model
		      Dimension width = 100%
		      int minTextLength = 1
		      int maxTextLength = 100
		      void(string value) onChange = null
		      void(string value) onInput = null
		      bool required = false
		      ValidationState validationState = {}
		      string help = ""
			  bool focusInitially = false
		      Reference<string> matchModel = null
		      string autocomplete = "current-password"
		      string name = "password"
		let currentValue = model or ""
		
		let container = column
			drawLabel label, required, help
			input width, value:currentValue
				borderRadius:8, border:{2px solid #d1d5db}
				outline:none, styleWhenFocused: {border:{2px solid primaryColor}}
				padding:{12 16}, fontSize:16, color:#2b3145
				data:{type:"password", autocomplete, name}, focusInitially
			onInput: value =>
				model = value
				if onInput != null then onInput(value)
				refresh
			onBlur:
				if model then	validationState.setShouldValidate(label)
				if onChange != null then	onChange(model)
				refresh

			if validationState.shouldValidate(label)
				if not currentValue and required then validationState[label] = "Bitte füllen Sie dieses Feld aus." else
				if matchModel != null and matchModel.value != currentValue then validationState[label] = "Passwörter stimmen nicht überein" else
				if currentValue.length < minTextLength then validationState[label] = "Ihr Passwort sollte mindestens {minTextLength} Zeichen lang sein" else
				if currentValue.length > maxTextLength then validationState[label] = "Ihr Passwort sollte maximal {maxTextLength} Zeichen lang sein" else
				                                            validationState[label] = ""
			showErrorMessage validationState[label]
		container.set "class", validationState[label] ? "validation-error" : ""

	toggle: string label
		    Reference<bool> model
		    Dimension width = 100%
		    Image[] images = [ToggleOff, ToggleOn]
		    void(bool value) onInput = null
		    bool required = false
		    ValidationState validationState = {}
		    string help = ""
			string errorMessage = "Dieses Feld ist erforderlich."
		let container = column
			row gap:12 alignItems:center, cursor:pointer
				let element = div tag:"img" height:24 marginTop:-3
				element.src = Platform.basePath + images[model ? 1 : 0].src
				drawLabel label, required, help
			onClick:
				model.assign not model
				validationState.setShouldValidate(label)
				if onInput != null then onInput(model)
				refresh
			if validationState.shouldValidate(label)
				let currentValue = model or false
				if not currentValue and required then	validationState[label] = errorMessage
				else	validationState[label] = ""
			showErrorMessage validationState[label]
		container.set "class", validationState[label] ? "validation-error" : ""

	// Radio button group
	radioGroup: string label = ""
		        Reference<string> model
		        string[] options
		        string[] optionLabels = []
		        void(string value) onChange = null
				FlexDirection flexDirection = row
				float gap = 32
		        bool required = false
		        string help = ""
		let labels = optionLabels.length > 0 ? optionLabels : options
		
		column
			drawLabel label, required, help
			div display:flex, gap, flexDirection
				for options as option, index
					let isSelected = (model or "") == option
					div display:flex, alignItems:center, gap:12, cursor:pointer
						onClick:
							model = option
							if onChange != null then onChange(option)
							refresh
						div width:20, height:20, borderRadius:10
							border:{width:2px, style:solid, color:isSelected ? primaryColor : #d1d5db}
							backgroundColor:isSelected ? primaryColor : white
							display:flex, alignItems:center, justifyContent:center
							if isSelected
								div width:10, height:10, borderRadius:5, backgroundColor:white
						div text:labels[index], fontSize:15, color:#40465a
